export const getIframeModeParams = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    isIframeMode: params.get('in_iframe') === 'true',
    // Host webview's Platform.OS ('ios' | 'android'), passed by Viome-mfe when
    // it embeds SMP in a native webview. Empty for browser (non-iframe) loads.
    os: params.get('os') ?? '',
    token: params.get('token'),
    customerId: params.get('customerId'),
    hasRecommendation: params.get('hasRecommendation') === 'true',
    hasPersonalizedSupplementRecommendations: params.get('hasPersonalizedSupplementRecommendations') === 'true',
    isEligibleForSupplements: params.get('isEligibleForSupplements') === 'true',
    subscriptionId: Number(params.get('subscriptionId')) || null,
  };
};
